import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
export const LoadingBar = ({ loading }) => _jsx(Loading, { "$loading": loading }, void 0);
// opacity transition 中加入 0.4s delay，请求很快时不显示 indicator
const Loading = styled.div `
  position: absolute;
  /* navbar 高度 */
  top: 52px;
  left: 0;
  z-index: 110;
  width: 100%;
  height: 3px;
  overflow: hidden;
  background: linear-gradient(
    90deg,
    ${p => p.theme.brand._4} 0%,
    ${p => p.theme.brand._4} 25%,
    ${p => p.theme.brand._1} 50%,
    ${p => p.theme.brand._4} 75%,
    ${p => p.theme.brand._4} 100%
  );
  background-size: 200%;
  transition: opacity 0.4s ease-in-out 0.4s;

  ${props => {
    if (props.$loading) {
        return `
        opacity: 1;
        animation: moveGradient 3s linear infinite;
      `;
    }
    return `
      opacity: 0;
      animation: moveGradient 1s linear 1;
    `;
}};

  @keyframes moveGradient {
    0% {
      background-position: 0% 0%;
    }
    100% {
      background-position: -200% 0%;
    }
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTG9hZGluZ0Jhci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9BcHBMYXlvdXQvY29tcG9uZW50cy9Mb2FkaW5nQmFyLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBTUEsT0FBTyxNQUFNLE1BQU0sbUJBQW1CLENBQUE7QUFFdEMsTUFBTSxDQUFDLE1BQU0sVUFBVSxHQUVsQixDQUFDLEVBQUUsT0FBTyxFQUFFLEVBQUUsRUFBRSxDQUFDLEtBQUMsT0FBTyxnQkFBVyxPQUFPLFdBQUksQ0FBQTtBQUVwRCx1REFBdUQ7QUFDdkQsTUFBTSxPQUFPLEdBQUcsTUFBTSxDQUFDLEdBQUcsQ0FBdUI7Ozs7Ozs7Ozs7O01BVzNDLENBQUMsQ0FBQyxFQUFFLENBQUMsQ0FBQyxDQUFDLEtBQUssQ0FBQyxLQUFLLENBQUMsRUFBRTtNQUNyQixDQUFDLENBQUMsRUFBRSxDQUFDLENBQUMsQ0FBQyxLQUFLLENBQUMsS0FBSyxDQUFDLEVBQUU7TUFDckIsQ0FBQyxDQUFDLEVBQUUsQ0FBQyxDQUFDLENBQUMsS0FBSyxDQUFDLEtBQUssQ0FBQyxFQUFFO01BQ3JCLENBQUMsQ0FBQyxFQUFFLENBQUMsQ0FBQyxDQUFDLEtBQUssQ0FBQyxLQUFLLENBQUMsRUFBRTtNQUNyQixDQUFDLENBQUMsRUFBRSxDQUFDLENBQUMsQ0FBQyxLQUFLLENBQUMsS0FBSyxDQUFDLEVBQUU7Ozs7O0lBS3ZCLEtBQUssQ0FBQyxFQUFFO0lBQ1IsSUFBSSxLQUFLLENBQUMsUUFBUSxFQUFFO1FBQ2xCLE9BQU87OztPQUdOLENBQUE7S0FDRjtJQUVELE9BQU87OztLQUdOLENBQUE7QUFDSCxDQUFDOzs7Ozs7Ozs7O0NBVUYsQ0FBQSJ9